// Forecast data is reused for this long before the API is called again (matches the backend TTL).
export const FORECAST_TTL_MS = 60 * 60 * 1000;

export const isForecastFresh = (forecast) => {
  const fetchedAt = forecast?.fetched_at ? new Date(forecast.fetched_at).getTime() : NaN;
  return !Number.isNaN(fetchedAt) && Date.now() - fetchedAt < FORECAST_TTL_MS;
};
